import { RESET_ALL_STATES } from '../actions/actions';

const initialState = {
  uin: null,
  verificationMethod: null,
};

const setUIN = (state = initialState, action) => {
    
  switch (action.type) {
    case "SET_UIN":
      return {
        ...state,
        uin: action.payload.uin,
        verificationMethod: action.payload.verificationMethod,
      };
    case "CLEAR_UIN":
      return {
        ...state,
        uin: null,
        verificationMethod: null, 
      };
    
    case RESET_ALL_STATES:
        return initialState;
    default:
      return state;
  }
};

export default setUIN;
